import { Rx, RxList } from "subtree.js/core";
import { idleLoad, type LoadStatus } from "../../core/primitives/load-status";
import type { WorkspaceOption } from "../../core/primitives/workspace";

export class ChooseWorkspaceState {
  readonly status = new Rx<LoadStatus>(idleLoad);
  readonly options = new RxList<WorkspaceOption>();
}

export abstract class ChooseWorkspaceActions {
  abstract choose(option: WorkspaceOption): void;
  abstract retry(): void;
}
